/**
 * Version service - provides player version information
 */

// Import version from generated file (using @ alias for src directory)
import versionData from '@/version.json';

class VersionService {
  private version: string;

  constructor() {
    this.version = versionData.version || 'unknown';
  }

  /**
   * Get the current player version
   * Format:
   * - Tag-based: "v1.2.3" or "v1.2.3-dirty"
   * - Commit-based: "abc1234" or "abc1234-dirty"
   */
  public getVersion(): string {
    return this.version;
  }

  /**
   * Get version with additional metadata
   */
  public getVersionInfo(): { version: string; isDirty: boolean; isTagged: boolean } {
    const isDirty = this.version.endsWith('-dirty');
    const isTagged = /^v\d+\.\d+\.\d+/.test(this.version);

    return {
      version: this.version,
      isDirty,
      isTagged
    };
  }

  /**
   * Log version to console
   */
  public logVersion(): void {
    const info = this.getVersionInfo();
    console.log(`[ETV Player] Version: ${info.version}${info.isDirty ? ' (uncommitted changes)' : ''}${info.isTagged ? ' (tagged release)' : ' (commit)'}`);
  }
}

export const versionService = new VersionService();
